import React, { useCallback, useEffect, useMemo, useState } from 'react';
import SettingsMainLayout from 'components/organisms/settings/MainLayoutV2';
import {
  useSettingsForm,
  useSettingsMainForm,
} from 'hooks/formStates/settings';
import routeCodes from 'common/constants/route-codes';
import { useCommon } from 'redux/common/use-common';
import SettingsApi from 'libs/api/settings';
import UIHelper from 'services/UIHelper';
import ServicesApi from 'libs/api/services';
import ServicesList from 'components/molecules/settings/v2/ServicesList';
import { Divider } from 'components/atoms/styleds';
import { useUser } from 'redux/user/use-user';
import Modal from '../../components/molecules/Modal';

const SettingsV2 = ({ history }) => {
  const [localUpdateInProcess, setLocalUpdateInProcess] = useState(false);
  const [errors, setErrors] = useState(null);
  const [exceptionErrors, setExceptionErrors] = useState(null);
  const [list, setList] = useState([]);
  const [deletableItem, setDeletableItem] = useState(null);
  const [deleteInProcess, setDeleteInProcess] = useState(false);

  const { isSuperAdmin } = useUser();

  const {
    onSelectConfig,
    onChange,
    localState,
    dataForRequest,
  } = useSettingsMainForm(true);

  const onCancel = useCallback(() => {
    history.push(routeCodes.home);
  }, [history]);

  const {
    deliveryDates,
    deliveryActiveTab,
    fetchDeliveryDates,
    changeDeliveryDayConfig,
    onChangeDeliveryTab,
    setHoursErrors,
    onChangeMaximum,
    onChangeExceptionDay,
    onAddExceptionData,
    isLoading,
    onDeleteException,
    onAddNewException,
    setDeliveryDates,
  } = useSettingsForm();
  const { currentRestaurant } = useCommon();

  const settingsApi = useMemo(() => {
    return new SettingsApi(currentRestaurant?.id);
  }, [currentRestaurant]);

  const api = useMemo(() => {
    return new ServicesApi(currentRestaurant?.id);
  }, [currentRestaurant]);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.list();
        setList(data.services);
      } catch (e) {}
    })();
  }, [currentRestaurant]);
  const handleUpdateSettingTimes = useCallback(async () => {
    setLocalUpdateInProcess(true);
    const { opening_hour_exceptions, opening_hours, settings } = deliveryDates[
      deliveryActiveTab
      ];
    const preparedExceptions = [];
    opening_hour_exceptions?.forEach((exc) => {
      const { id, ...rest } = exc;
      preparedExceptions.push(Number.isInteger(id) ? exc : rest);
    });
    try {
      await settingsApi.updateOpeningHours(deliveryActiveTab, {
        opening_hour_exceptions: preparedExceptions,
        opening_hours,
        settings,
      });
      const { data: newData } = await settingsApi.get(
        `opening_hours/${deliveryActiveTab}`,
      );
      setDeliveryDates((state) => ({
        ...state,
        [deliveryActiveTab]: {
          ...state[deliveryActiveTab],
          isFetched: true,
          errors: null,
          ...newData,
        },
      }));
      UIHelper.showCreateOrUpdateSuccess();
    } catch (e) {
      setErrors(e?.response?.data?.opening_hours);
      setExceptionErrors(e?.response?.data?.opening_hour_exceptions);
    } finally {
      setLocalUpdateInProcess(false);
    }
  }, [deliveryActiveTab, dataForRequest, deliveryDates, api, settingsApi]);

  const onClickDelete = useCallback(async (item) => {
    setDeleteInProcess(true);
    try {
      await api.destroy(item.id);
      UIHelper.showSuccessMessage();
      setDeletableItem(true);
      await (async () => {
        try {
          const { data } = await api.list();
          setList(data.services);
        } catch (e) {}
      })();
    } catch (e) {
    } finally {
      setDeleteInProcess(false);
    }
  }, []);

  const deleteItem = () => {
    onClickDelete(deletableItem);
  };

  const handleDelete = (item) => {
    setDeletableItem(item);
  };

  return (
    <SettingsMainLayout
      localState={localState}
      onChange={onChange}
      onSubmitAction={handleUpdateSettingTimes}
      onSelectConfig={onSelectConfig}
      onCancel={onCancel}
      setOpeningHourErrors={setErrors}
      openingHourErrors={errors}
      localUpdateInProcess={localUpdateInProcess}
      changeDeliveryDayConfig={changeDeliveryDayConfig}
      deliveryActiveTab={deliveryActiveTab}
      deliveryDates={deliveryDates}
      fetchDeliveryDates={fetchDeliveryDates}
      onChangeDeliveryTab={onChangeDeliveryTab}
      setHoursErrors={setHoursErrors}
      onChangeMaximum={onChangeMaximum}
      onChangeExceptionDay={onChangeExceptionDay}
      onAddExceptionData={onAddExceptionData}
      isLoading={isLoading}
      onDeleteException={onDeleteException}
      onAddNewException={onAddNewException}
      exceptionErrors={exceptionErrors}
      isSuperAdmin={isSuperAdmin}
      setDeliveryDates={setDeliveryDates}
    >
      <Divider style={{ width: '100%' }} />
      <ServicesList
        currentRestaurant={currentRestaurant}
        isSuperAdmin={isSuperAdmin}
        onDelete={handleDelete}
        inProcess={deleteInProcess}
        list={list}
      />
      {deletableItem && (
        <Modal
          open={true}
          onClose={() => setDeletableItem(null)}
          inProcess={deleteInProcess}
          onSubmit={deleteItem}
          headerCenter={true}
          onCancel={() => setDeletableItem(null)}
          // body={modalData.body}
          actionButtonText='Conferma'
          title='Vuoi cancellare?'
          // variant={modalData.variant}
        />
      )}
    </SettingsMainLayout>
  );
};

export default SettingsV2;
